import type { PostClientSignup } from '@lt/api/dist/methods/client/types';
import {
  resetPhoneFormat,
  resetPersonDataFormat,
} from 'src/components/AuthNew/utils';
import { isEmpty } from 'lodash';
import { i18n } from '@lt/localization';
import type { QueryParams } from 'src/components/AuthNew/types';
import type { FormValues } from '../types';
import { FormFields } from '../types';

export const mapValuesToSubmit =
  (queryParams?: QueryParams) =>
  (values: FormValues): PostClientSignup => ({
    client: {
      name: resetPersonDataFormat(values?.name ?? ''),
      surname: resetPersonDataFormat(values?.surname ?? ''),
      phone: resetPhoneFormat(values?.phone ?? ''),
      email: resetPersonDataFormat(values?.email ?? ''),
      advertising_mail_accepted: values?.acceptPromotions ?? false,
      ...(values.id && { id: values.id }),
      ...queryParams,
    },
    use_cookies: true,
  });

export const checkSubmitDisabled = (values: FormValues): boolean =>
  isEmpty(values.name) ||
  isEmpty(values.surname) ||
  isEmpty(values.phone) ||
  isEmpty(values.email) ||
  !values.acceptProcessingPersonalData;

export const registrationErrorMap = {
  email_taken: {
    name: FormFields.Email,
    message: `${i18n.t('checkout.registrationForm.email.error')}. `,
  },
  phone_taken: {
    name: FormFields.Phone,
    message: `${i18n.t('checkout.registrationForm.phone.error')}. `,
  },
  otp_phone_taken: {
    name: FormFields.Phone,
    message: `${i18n.t('checkout.registrationForm.phone.error')}. `,
  },
};
